import React, { useEffect } from 'react';
import airbnbLogo from './airbnb-logo.png';
import whatsappLogo from './whatsapp-logo.png';
import sampleQRCode from './qr-code.jpg';
import { Link } from 'react-router-dom';
import whatsappImage from './WhatsApp-Image.jpeg';
import './homepage.css'




const Homepage = () => {
    useEffect(() => {
        // Load the Botpress chatbot
        const botpressScript1 = document.createElement('script');
        botpressScript1.src = "https://cdn.botpress.cloud/webchat/v0/inject.js";
        document.body.appendChild(botpressScript1);

        const botpressScript2 = document.createElement('script');
        botpressScript2.src = "https://mediafiles.botpress.cloud/442b2796-4808-43f5-ac88-e03a826336cc/webchat/config.js";
        botpressScript2.defer = true;
        document.body.appendChild(botpressScript2);

        // Cleanup to prevent adding multiple scripts if component is re-rendered
        return () => {
            document.body.removeChild(botpressScript1);
            document.body.removeChild(botpressScript2);
        };

        
    }, []);

    return (
        <main>
            <Header />
            <About />
            <Features />
            <Pricing />
            <div className="faq-section">
                <FAQ />
                <ContactButton />
            </div>
            <UsageExample /> 
            <Contact />
        </main>
    );
};

const ContactButton = () => (
    <Link to="/Contact" className="btn proceed-payment-btn">Contact us</Link>
);

const openBotChat = () => {
    if (window.botpressWebChat) {
        window.botpressWebChat.sendEvent({ type: 'show' });
    } else {
        console.error("Botpress object is not available yet.");
    }
};

const Header = () => (
    <header className="header">
        <div className="container text-center">

            <h1><span className="icon">🤖</span> 24/7 Chatbot Support for Airbnb Hosts</h1>
            <img src={airbnbLogo} alt="Airbnb" className="mb-4" style={{ width: '150px'}} />
            <p className="lead">Enhance guest experience, save time, and manage inquiries seamlessly.</p>
            <button className="btn proceed-payment-btn" onClick={openBotChat}>See bot in action</button>
        </div>
    </header>
);




const Features = () => (
    <section className="features container" id="features">
        <h2 className="section-title">Our Key Promises</h2>

        <div className="feature-card">
            <span className="icon">🌍</span>
            <h2>Multilingual Support</h2>
            <p>Engage and connect with a global audience effortlessly. Our advanced chatbot supports a vast array of languages, ensuring every guest feels valued and understood. Break down language barriers and offer a seamless experience for users worldwide.</p>
        </div>

        <div className="feature-card">
            <img src={whatsappLogo} alt="WhatsApp" style={{ width: '50px', marginRight: '10px' }} />
            <h2>Integration with WhatsApp</h2>
            <p>Reach your guests where they are most active. With our seamless integration into WhatsApp, guests can access support, make inquiries, and receive real-time responses, all from their preferred messaging platform.</p>
            <p className="whatsapp-demo"><b>Try the bot now on WhatsApp:</b> 
            <br></br>
            <a href="https://wa.me/447457405612">+44 7457 405612</a></p>
        </div>

        <div className="feature-card">
            <span className="icon">⏰</span>
            <h2>24/7 Availability</h2>
            <p>Round-the-clock support means your guests are never left waiting. Our chatbot is always available, ensuring timely and consistent assistance, regardless of time zones or business hours. Experience uninterrupted guest support, day or night.</p>
        </div>
    </section>
);




const About = () => (
    <section className="about container" id="about">
        <div className="about-inner">
            <div className="about-text">
                <h2 className="section-title">Discover StayAssist</h2>
                <p className="intro-text">Your 24/7 digital concierge, tailored for Airbnb hosts. Ensuring every guest has the answers, anytime they need.</p>
                <div className="benefits">
                    <div className="benefit-card">
                        <span className="icon">⚡</span>
                        <h3>Immediate Responses</h3>
                        <p>Guests receive instant answers, without the wait.</p>
                    </div>
                    <div className="benefit-card">
                        <span className="icon">🌟</span>
                        <h3>Enhanced Experience</h3>
                        <p>Boost guest satisfaction and earn better reviews.</p>
                    </div>
                    <div className="benefit-card">
                        <span className="icon">🤖</span>
                        <h3>Advanced AI Capabilities</h3>
                        <p>Powered by sophisticated machine learning, our chatbot understands a wide range of guest inquiries.</p>
                    </div>
                    <div className="benefit-card">
                        <span className="icon">🔗</span>
                        <h3>Ready Integration</h3>
                        <p>Seamless integration with platforms like WhatsApp.</p>
                    </div>
                </div>
            </div>
            <div className="about-image">
                <img src={whatsappImage} alt="Chatbot in action on WhatsApp" /> {/* Use the imported variable here */}
            </div>
        </div>
    </section>
);






const Pricing = () => (
    <section className="pricing" id="pricing">
        <div className="card-container text-center">  {/* Added this div */}
            <div className="modern-card">
                <h2 className="section-title">Straightforward Pricing</h2>
                <ul className="features-list">
                    <li>24/7 Multilingual Chatbot Support</li>
                    <li>Seamless Integration with Airbnb listings</li>
                    <li>Dedicated WhatsApp Phone Number</li>
                    <li>Regular Chatbot Updates & Enhancements</li>
                    <li>Assistance and customization</li>
                    <li>AI-Powered Understanding: Advanced machine learning ensures our bot comprehends and responds to varied guest inquiries.</li>
                </ul>
                <div className="price-tag">
                    <span className="price-amount">On demand</span>
                    <span className="price-info">(One-time setup)</span>
                </div>
                <div className="maintenance-tag">
                    <span className="maintenance-amount">On demand/month</span>
                    <span className="maintenance-info">(Including updates & modifications)</span>
                </div>
                <p>Unlock the full potential of your hosting with StayAssist.</p>

                <Link to="/COntact" className="btn proceed-payment-btn">Contact us</Link>


            </div>
        </div>
    </section>
);





// ... Other React components ...

const FAQ = () => {
    const [activeIndex, setActiveIndex] = React.useState(null);

    const toggleFAQ = (index) => {
        if (activeIndex === index) {
            setActiveIndex(null);
        } else {
            setActiveIndex(index);
        }
    };

    const faqs = [
        {
            question: "How personalized will my chatbot be?",
            answer: "Your chatbot will be tailored based on the specific details you provide about your property. From images to specific amenities and house rules, the bot will be customized to answer guest inquiries specific to your property."
        },
        {
            question: "What kind of information do I need to provide for my personalized chatbot?",
            answer: "After payment, you'll be prompted to fill out a form where you can provide images, explanations about amenities, house rules, local tips, and any other specifics that you'd like your guests to know. The more detailed and comprehensive your information, the better your chatbot will assist your guests."
        },
        {
            question: "How long does it take to set up my personalized chatbot after I've submitted all the details?",
            answer: "Once we receive all the required details from you, it typically takes 3-5 business days to set up and test your personalized chatbot. We ensure its functionality and accuracy before handing it over for your use."
        },
        {
            question: "Can I update the information on my chatbot after it has been set up?",
            answer: "Absolutely! If there are changes or updates related to your property, you can reach out to us, and we'll make the necessary modifications to your chatbot."
        },
        {
            question: "How does the AI in the chatbot work?",
            answer: "The chatbot uses advanced artificial intelligence to understand and answer guest queries. It is trained on the specific information you provide, ensuring accurate and relevant answers tailored to your property."
        },
        {
            question: "Do guests need to download anything to access the chatbot?",
            answer: "No, guests don't need to download any additional software. They can access and interact with the chatbot directly through the provided link or QR code (via whatsapp)."
        },
        {
            question: "What if a guest asks a question that wasn't covered in the information I provided?",
            answer: "Our chatbot is designed to handle a wide range of queries. If a guest asks something specific that wasn't covered in the details you provided, the bot will guide the guest to contact you directly or provide a general response based on its training. Additionally, we will alert you about the specific question asked by the guest, allowing you to update and fill in the missing information for future inquiries."
        },
        {
            question: "Is my information and the details I provide secure?",
            answer: "Yes, we prioritize the security and confidentiality of the information you provide. All data is encrypted, and we adhere to strict privacy standards to ensure your property details are protected."
        }
        
        
    ];


    return (
        <section className="faq container">
            <h2 className="section-title">FAQ</h2> {/* Added this line for the FAQ title */}
            <div className="faq-container">
                {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <div className="faq-question" onClick={() => toggleFAQ(index)}>
                            <span>{faq.question}</span>
                            <span className="icon">{activeIndex === index ? '-' : '+'}</span>
                        </div>
                        {activeIndex === index && <div className="faq-answer">{faq.answer}</div>}
                    </div>
                ))}
            </div>
        </section>
    );
};
const UsageExample = () => (
    <section className="usage-example container" id="usage-example">
        <div className="usage-content">
            <div className="usage-text">
                <h2 className="section-title">Easy Set Up</h2>
                <p className="intro-text">
                    Setting up StayAssist at your property is a breeze. In just three simple steps, you'll have your chatbot ready to assist your guests.
                </p>
                <div className="benefits">
                    <div className="benefit-card">
                        <span className="icon">1️⃣</span>
                        <h3>Provide Property Details</h3>
                        <p>Share specifics about your property, amenities, house rules, and any other relevant information.</p>
                    </div>
                    <div className="benefit-card">
                        <span className="icon">2️⃣</span>
                        <h3>Customize & Train</h3>
                        <p>We'll customize your chatbot based on the details provided and train it for accuracy.</p>
                    </div>
                    <div className="benefit-card">
                        <span className="icon">3️⃣</span>
                        <h3>Integrate & Go Live</h3>
                        <p>Integrate the chatbot with your Airbnb listing, and you're all set. It's that simple!</p>
                    </div>
                </div>
            </div>
            <div className="usage-image">
                <img src={sampleQRCode} alt="QR Code for accessing the chatbot" />
            </div>
        </div>
    </section>
);









const Contact = () => (
    <section className="contact">
        <p>Have questions or need personalized assistance? Reach out to us at ugo.richer@stayassist.fr or +33 6 66 96 45 50 on whatsapp</p>
    </section>
);



export default Homepage;